"use client";

import { useEffect } from "react";
import { datadogLogs } from "@datadog/browser-logs";
import { sdkLogger } from "../utils/logger";
import { clientEnv } from "../../lib/env";

export function DatadogInit() {
  useEffect(() => {
    // Runs after paint
    try {
      const clientToken = clientEnv.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

      if (!clientToken) {
        sdkLogger.warn("datadog_client_token_not_found", {
          message: "Skipping Datadog Logs initialization",
        });
        return;
      }

      datadogLogs.init({
        clientToken,
        site: "datadoghq.com",
        service: "wabasignup",
        forwardErrorsToLogs: true,
        forwardConsoleLogs: ["error"], // Only forward console.error (not all console logs)
        silentMultipleInit: true,
      });

      sdkLogger.info("datadog_logs_initialized");
    } catch (error) {
      // Fail silently - don't break the app if Datadog fails
      sdkLogger.error("failed_to_initialize_datadog_logs", {
        error: error instanceof Error ? error.message : String(error),
      });
    }
  }, []);

  // Always return null - never blocks rendering
  return null;
}
